class ProductOptionsGenerator {
  constructor(options, containerId) {
    this.options = options;
    this.container = document.getElementById(containerId);

    if (!this.container) {
      return;
    }

    this.section_id = this.container.getAttribute("section-related");
    this.selectedOptions = {};
    this.renderOptions();
  }

  renderOptions() {
    Object.entries(this.options).forEach(([key, values], index) => {
      const section = document.createElement("div");
      section.id = `F${index + 1}`;
      section.className = "product-section-option";
      section.dataset.foption = `F${index + 1}`;
      section.dataset.type = "color";
      section.style.order = index + 1;

      section.innerHTML = `
        <div class="product-section-option-header">
          <h4 class="ellip ellip-2 product-section-title">${key}</h4>
          <div class="helper-error">
            <i class="fas fa-exclamation-circle"></i>
            <span>Por favor elige ${key}</span>
          </div>
        </div>
        <div class="product-section-container" data-isprintcolorwidget="false">
          ${this.generateOptions(values, key)}
        </div>
        <div class="fa-3x start-loading">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
      `;

      this.container.appendChild(section);
    });
  }

  generateOptions(values, key) {
    return values.map((value, idx) => {
      let colorStyle = this.getColorGradient(value);

      return `
        <div class="product-option product-option-colorpicker ${idx === 0 ? "active" : ""} not-division" data-option-text="${value}">
          <div class="product-option-img d-none"></div>
          <div class="product-option-body">
            <div class="product-option-title-price">
              <div style="display: flex; flex-direction: column">
                <span class="product-option-title">${value}</span>
                <span class="product-prices d-none"></span>
              </div>
              <span class="product-option-color" style="${colorStyle}"></span>
            </div>
            <span class="product-option-description d-none"></span>
          </div>
        </div>
      `;
    }).join("");
  }

  getColorGradient(value) {
    if (value === "Colores") {
      return "background: linear-gradient(125deg,#0ff 21%,#f0f 49%,#ff0 76%)";
    } else if (value === "En Blanco Y Negro") {
      return "background: linear-gradient(125deg,#000 9%,#fff 73%)";
    }
    return "";
  }

  handleOptionClick(event) {
    const item = event.target.closest('.product-section-container-item');
    if (item) {
      const sectionItems = item.closest('.product-section-container').querySelectorAll('.product-section-container-item');
      sectionItems.forEach((el) => el.classList.remove('active'));
      item.classList.add('active');

      const optionKey = item.dataset.optionKey;
      const optionValue = item.dataset.optionValue;
      this.selectedOptions[optionKey] = optionValue;
      this.updateAddToCartForm();
    }
  }

  updateAddToCartForm() {}
}

const productOptions = {
  "Forma": ["Rectangular", "Cuadrangular"],
  "Tamaño": ["90 x 50 mm", "85 x 55 mm"],
  "Material": ["Couché 350 g", "Cartulina Sulfatada 270 g"],
  "Color de impresión": ["En Blanco Y Negro"],
  "Lados impresos": ["Frente y Vuelta", "Solo frente"],
  "Refinamiento": ["Sin acabado", "Plastificado Mate"]
};

document.addEventListener("DOMContentLoaded", function () {
  const productOptionsGenerator = new ProductOptionsGenerator(productOptions, "options-container");
  document.getElementById("options-container")?.addEventListener("click", (event) => {
    productOptionsGenerator.handleOptionClick(event);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.qty-row').forEach(row => {
    row.addEventListener('click', () => {
      document.querySelectorAll('.qty-row').forEach(r => r.classList.remove('active'));
      row.classList.add('active');
      const qty = row.getAttribute('data-qty');
      document.getElementById('variantQtyInput').value = qty;
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const propertiesContainer = document.getElementById('properties-container');
  const propertiesScript = document.getElementById('product-properties');
  const form = document.querySelector('form[action="/cart/add"]');

  if (!propertiesContainer || !propertiesScript || !form) {
    return;
  }

  const propertiesData = JSON.parse(propertiesScript.textContent);

  const propertiesByType = propertiesData.properties.reduce((acc, property) => {
    if (!acc[property.type]) {
      acc[property.type] = [];
    }
    acc[property.type].push(property);
    return acc;
  }, {});

  const variantStepCount = document.querySelectorAll('.variant-wrapper[data-gp-step]').length;
  let stepIndex = variantStepCount;

  Object.entries(propertiesByType).forEach(([type, properties]) => {
    stepIndex++;

    const stepDiv = document.createElement('div');
    stepDiv.className = 'gp-configurator__step';
    stepDiv.dataset.gpStep = '';

    const stepHeader = document.createElement('div');
    stepHeader.className = 'gp-configurator__step-header';

    const badge = document.createElement('span');
    badge.className = 'gp-configurator__step-badge';
    badge.textContent = stepIndex;
    stepHeader.appendChild(badge);

    const titleEl = document.createElement('span');
    titleEl.className = 'gp-configurator__step-title';
    titleEl.textContent = type;
    stepHeader.appendChild(titleEl);

    stepDiv.appendChild(stepHeader);

    const optionsDiv = document.createElement('div');
    optionsDiv.className = 'property-options';

    properties.forEach(property => {
      const optionDiv = document.createElement('div');
      optionDiv.className = 'property-option';
      optionDiv.dataset.propertyId = property.id;
      optionDiv.dataset.propertyType = property.type;
      optionDiv.dataset.propertyTitle = property.title;

      if (property.icon) {
        const img = document.createElement('img');
        img.src = property.icon;
        img.alt = property.title;
        img.className = 'property-icon';
        img.width = 24;
        img.height = 24;
        optionDiv.appendChild(img);
      }

      const titleSpan = document.createElement('span');
      titleSpan.className = 'property-title';
      titleSpan.textContent = property.title;
      optionDiv.appendChild(titleSpan);

      if (property.title === "Colores") {
        const colorSpan = document.createElement('span');
        colorSpan.className = 'product-option-color';
        colorSpan.style.background = 'linear-gradient(125deg,#0ff 21%,#f0f 49%,#ff0 76%)';
        optionDiv.appendChild(colorSpan);
      }

      if (property.title === "En Blanco Y Negro") {
        const colorSpan = document.createElement('span');
        colorSpan.className = 'product-option-color';
        colorSpan.style.background = 'linear-gradient(125deg,#000 9%,#fff 73%)';
        optionDiv.appendChild(colorSpan);
      }

      if (property.label) {
        const labelBadge = document.createElement('span');
        labelBadge.className = 'badge';
        labelBadge.textContent = property.label;
        optionDiv.appendChild(labelBadge);
      }

      optionDiv.setAttribute('role', 'button');
      optionDiv.setAttribute('tabindex', '0');
      optionDiv.setAttribute('aria-pressed', 'false');

      optionDiv.addEventListener('click', function() {
        selectPropertyOption(stepDiv, this, type, property.title);
      });

      optionDiv.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectPropertyOption(stepDiv, this, type, property.title);
      });

      optionsDiv.appendChild(optionDiv);
    });

    stepDiv.appendChild(optionsDiv);
    propertiesContainer.appendChild(stepDiv);

    const firstOption = optionsDiv.querySelector('.property-option');
    if (firstOption) {
      selectPropertyOption(stepDiv, firstOption, type, firstOption.dataset.propertyTitle);
    }
  });

  function selectPropertyOption(stepDiv, selectedOption, type, title) {
    const sameTypeOptions = stepDiv.querySelectorAll('.property-option');
    sameTypeOptions.forEach(opt => {
      opt.classList.remove('active');
      opt.setAttribute('aria-pressed', 'false');
    });

    selectedOption.classList.add('active');
    selectedOption.setAttribute('aria-pressed', 'true');
    updateFormProperty(type, title);
  }

  function updateFormProperty(type, title) {
    const existingInput = form.querySelector(`input[name="properties[${type}]"]`);
    if (existingInput) {
      existingInput.remove();
    }

    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${type}]`;
    input.value = title;
    form.appendChild(input);
  }
});

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const configurator = document.querySelector('[data-gp-configurator]');
    if (!configurator) return;

    const productSection = configurator.closest('[data-section-type="product"]');
    if (!productSection) return;

    const priceEl = productSection.querySelector('[data-product-price]');
    const totalEl = configurator.querySelector('[data-gp-total-price]');
    if (!priceEl || !totalEl) return;

    function syncTotal() {
      totalEl.textContent = priceEl.textContent.trim();
    }

    syncTotal();

    const observer = new MutationObserver(syncTotal);
    observer.observe(priceEl, { childList: true, characterData: true, subtree: true });

    productSection.addEventListener('variantChange', syncTotal);
    productSection.addEventListener('variantPriceChange', syncTotal);
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  const addToCartButton = document.querySelector('[data-add-to-cart]');
  if (!addToCartButton) return;

  function moveSwymButton() {
    const swymContainer = document.querySelector('.swym-atw-button-container');
    if (!swymContainer) return false;

    if (swymContainer.previousElementSibling === addToCartButton) return true;

    addToCartButton.insertAdjacentElement('afterend', swymContainer);
    return true;
  }

  if (moveSwymButton()) return;

  const observer = new MutationObserver(function() {
    if (moveSwymButton()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(function() {
    observer.disconnect();
  }, 10000);
});
